import React from 'react';
import { connect } from 'react-redux';
import CreateFolderForm from 'components/event/FileSystem/CreateFolderForm';
import StyledModalHeader from 'components/modal/StyledModalHeader';
import StyledModalBody from 'components/modal/StyledModalBody';

import { createFolder } from 'actions/Event';

import { clearModal } from 'actions';

import { Modal } from 'reactstrap';

const CreateFolderModal = ({
  modalOpen,
  createFolder,
  clearModal,
  teamId,
  eventId,
  items,
}) => {
  const clearFolderModal = clearModal.bind(null, 'CREATE_FS_FOLDER');

  return (
    <Modal isOpen={modalOpen} toggle={clearFolderModal}>
      <StyledModalHeader toggle={clearFolderModal}>
        Create folder
      </StyledModalHeader>
      <StyledModalBody>
        <CreateFolderForm
          items={items}
          onSubmit={createFolder.bind(null, teamId, eventId)}
          onCancel={clearFolderModal}
        />
      </StyledModalBody>
    </Modal>
  );
};

export default connect(
  ({ modal, eventFSObjects }) => {
    const props = {
      modalOpen: modal && modal.type === 'CREATE_FS_FOLDER',
      items: eventFSObjects,
    };

    if (props.modalOpen) {
      return { ...props, ...modal.initialValue };
    }

    return props;
  },
  {
    clearModal,
    createFolder,
  },
)(CreateFolderModal);
